module.exports = require("./sn.js");